import React, { useState, useEffect } from 'react';
import { List, Button, Typography, Skeleton, Pagination, Space, Card, message } from 'antd';
import { DownloadOutlined, FileExcelOutlined } from '@ant-design/icons';
import { getReportsSerials } from '../../../services/seriales';
import moment from 'moment';
import Layouts from '../../../components/Layouts';

const { Title, Text } = Typography;

const ReportsSerials = () => {
    const [reports, setReports] = useState([]);
    const [loading, setLoading] = useState(false);
    const [currentPage, setCurrent] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [downloadingFile, setDownloadingFile] = useState(null);

    const GetData = async () => {
        setLoading(true);
        try {
            const response = await getReportsSerials();
           
            if (response) {
                setReports(response.files);
            }
        } catch (error) {
            message.error('Error al cargar los reportes');
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    const handleDownload = async (filename) => {
        setDownloadingFile(filename);
        try {
            const downloadUrl = `${process.env.REACT_APP_URL_SERIAL}/reports/files/${filename}`;
            const downloadWindow = window.open(downloadUrl, '_blank');
            
            // Cerrar la ventana después de un breve momento para permitir la descarga
            setTimeout(() => {
                if (downloadWindow) {
                    downloadWindow.close();
                }
            }, 1000);
            
            message.success('Descarga iniciada');
        } catch (error) {
            message.error('Error al descargar el archivo');
            console.error(error);
        } finally {
            setDownloadingFile(null);
        }
    };

    useEffect(() => {
        GetData();
    }, []);

    const handlePageChange = (page, size) => {
        setCurrent(page);
        setPageSize(size);
    };

    // Calcular datos paginados
    const startIndex = (currentPage - 1) * pageSize;
    const endIndex = startIndex + pageSize;
    const paginatedReports = reports.slice(startIndex, endIndex);

    return (
        <Layouts>
            <Title level={3}>Reportes de Seriales</Title>
            
            <Card>
                {loading ? (
                    <div>
                        {Array.from({ length: pageSize }).map((_, index) => (
                            <div key={index} style={{ marginBottom: '16px' }}>
                                <Skeleton active paragraph={{ rows: 2 }} />
                            </div>
                        ))}
                    </div>
                ) : (
                    <>
                        <List
                            dataSource={paginatedReports}
                            renderItem={(item) => (
                                <List.Item
                                    actions={[
                                        <Button
                                            type="primary"
                                            icon={<DownloadOutlined />}
                                            onClick={() => handleDownload(item.filename)}
                                            loading={downloadingFile === item.filename}
                                            disabled={downloadingFile !== null}
                                        >
                                            Descargar archivo
                                        </Button>
                                    ]}
                                >
                                    <List.Item.Meta
                                        avatar={<FileExcelOutlined style={{ fontSize: '24px', color: '#52c41a' }} />}
                                        title={
                                            <Space>
                                                <Text strong>{item.filename}</Text>
                                            </Space>
                                        }
                                        description={
                                            <Text type="secondary">
                                                Creado: {moment(item.creation_date).format('DD/MM/YYYY HH:mm:ss')}
                                            </Text>
                                        }
                                    />
                                </List.Item>
                            )}
                        />
                        
                        {reports.length > 0 && (
                            <div style={{ marginTop: '16px', textAlign: 'center' }}>
                                <Pagination
                                    current={currentPage}
                                    pageSize={pageSize}
                                    total={reports.length}
                                    onChange={handlePageChange}
                                    showSizeChanger
                                    showQuickJumper
                                    showTotal={(total, range) =>
                                        `${range[0]}-${range[1]} de ${total} reportes`
                                    }
                                    pageSizeOptions={['10', '20', '50']}
                                />
                            </div>
                        )}
                        
                        {reports.length === 0 && !loading && (
                            <div style={{ textAlign: 'center', padding: '40px' }}>
                                <Text type="secondary">No hay reportes disponibles</Text>
                            </div>
                        )}
                    </>
                )}
            </Card>
        </Layouts>
    );
};

export default ReportsSerials;